import React from "react";

// components
import DiHeader from "../components/digital-infrastructure/diHeader";
import Whydi from "../components/digital-infrastructure/WhyDi";
import TypesOfDia from "../components/digital-infrastructure/TypesOfDia";
import CoreNetwork from "../components/digital-infrastructure/CoreNetwork";
import FourthUtility from "../components/digital-infrastructure/FourthUtility";
import CurrentMarket from "../components/digital-infrastructure/CurrentMarket";
import PrePreFooter from "../components/pre-footer/PrePreFooter";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

const DiWrapper = () => {
  return (
    <>
      <DiHeader />
      <Whydi />
      <TypesOfDia />
      <CoreNetwork />
      <FourthUtility />
      <CurrentMarket />
      <PrePreFooter>
        <p>
          1. Indeema.com, “Best Cloud Platform for IoT in 2022: GCP vs AWS vs
          Azure”, March 25, 2022.. <br />
          2. DataCenterDynamics.com, “Why the future of data management requires us
          to remove fragmented thinking”, May 10, 2021. The figures from 2021 to
          2025 were calculated by Statista based on the 2020 forecast figure and
          the five-year compound annual growth rate (CAGR) of 23 percent
          provided by International Data Corporation.
          <br /> 3. Barclay’s Equity Research Report: U.S. Communications
          Infrastructure, July 15, 2020, includes towers, small cells and
          distributed antenna systems.
        </p>
      </PrePreFooter>
      <PreFooter />
      <Footer />
    </>
  );
};

export default DiWrapper;
